import React, {Component} from 'react'
import {Input} from 'antd'

class TextColumn extends Component {
  render() {
    const {record, column, value, dataIndex, onChange} = this.props
    return record.editable ? (
      <Input
        value={value}
        style={{width: '100%'}}
        onChange={e =>
          onChange(e.target.value, record._key || record[dataIndex], column)
        }
      />
    ) : (
      <span>{value}</span>
    )
  }
}

TextColumn.propTypes = {}
TextColumn.defaultProps = {dataIndex: 'key'}

export default TextColumn
